export default __webpack_public_path__ + "static/B0244-d7f769b3e9f31602acaed57e55cba7b9.png";